var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetupSheet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0H6.5C5.4 0 4.5 0.9 4.5 2V18C4.5 19.1 5.4 20 6.5 20H18.5C19.6 20 20.5 19.1 20.5 18V6L14.5 0ZM18.5 18H6.5V2H13.5V7H18.5V18ZM2.5 4V22H18.5V24H2.5C1.4 24 0.5 23.1 0.5 22V4H2.5ZM8.5 10V12H16.5V10H8.5ZM8.5 14V16H13.5V14H8.5Z",
    fill: "#474949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupSheet);
export default __webpack_public_path__ + "static/media/setupSheet.b97057b30de6ab449d3680a95acc0396.svg";
export { ForwardRef as ReactComponent };